import { AccessController } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useUpdateAccessControllerQuery = (accessControllerId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/access-controllers/${accessControllerId}`
	return useLazyQuery<AccessController, void>(url, "PATCH")
}
